/** Matches backend `peQuoteStatus` enum in liveController.ts */
import { liveStatusLabel } from "../helpers/reportingStatuses";

export const peQuoteStatus = Object.freeze({
  quoteCreated: "quoteCreated",
  consentEmailSent: "consentEmailSent",
  sentToCustomer: "sentToCustomer",
  sentToBroker: "sentToBroker",
  customerCompleted: "customerCompleted",
  quoteDocumentsSent: "quoteDocumentsSent",
  policyDocumentsSent: "policyDocumentsSent",
});

/** Human-readable labels aligned with dashboard/reports via reportingStatuses. */
export const peQuoteStatusLabel = Object.freeze(
  Object.values(peQuoteStatus).reduce((acc, status) => {
    acc[status] = liveStatusLabel(status);
    return acc;
  }, {})
);

/**
 * @param {string|null|undefined} status - Raw status from API or UI
 * @returns {string} Label for display; unknown values pass through unchanged.
 */
export function getPeQuoteStatusLabel(status) {
  if (status == null || status === "") {
    return "—";
  }
  if (status === "Not Complete") {
    return liveStatusLabel("Not Complete");
  }
  return liveStatusLabel(status);
}

/** Raw values for Quotes table filters if needed later. */
export const peQuoteFilterableStatuses = Object.freeze([
  peQuoteStatus.quoteCreated,
  peQuoteStatus.consentEmailSent,
  peQuoteStatus.sentToCustomer,
  peQuoteStatus.sentToBroker,
  peQuoteStatus.customerCompleted,
  peQuoteStatus.quoteDocumentsSent,
  peQuoteStatus.policyDocumentsSent,
  "Not Complete",
]);

/** `{ text, value }[]` for Element UI `el-table-column` `:filters`. */
export function getPeQuoteStatusFilterOptions() {
  return peQuoteFilterableStatuses.map((value) => ({
    text: getPeQuoteStatusLabel(value),
    value,
  }));
}

/** CSS modifier suffix for pill styling (optional; align with Quotes.vue). */
const PILL_MODIFIER = Object.freeze({
  [peQuoteStatus.quoteCreated]: "quote-created",
  [peQuoteStatus.consentEmailSent]: "consent-email-sent",
  [peQuoteStatus.sentToCustomer]: "sent-to-customer",
  [peQuoteStatus.sentToBroker]: "sent-to-broker",
  [peQuoteStatus.customerCompleted]: "customer-completed",
  [peQuoteStatus.quoteDocumentsSent]: "quote-documents-sent",
  [peQuoteStatus.policyDocumentsSent]: "policy-documents-sent",
  "Not Complete": "not-complete",
});

/**
 * @param {string|null|undefined} rawStatus - Value from API before label mapping
 * @returns {string} Classes for status pill
 */
export function getPeQuoteStatusPillClass(rawStatus) {
  const base = "pe-quote-status-pill";
  if (rawStatus == null || rawStatus === "") {
    return `${base} ${base}--empty`;
  }
  const mod = PILL_MODIFIER[rawStatus];
  if (mod) {
    return `${base} ${base}--${mod}`;
  }
  return `${base} ${base}--other`;
}
